import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {clearCashAppCashout} from '../../../../reducers/app/actions';
import PageLoader from '../../../components/loader_page';

export default ({order}) => {
    const navigate = useNavigate(), 
          dispatch = useDispatch();

    if(!order)
        return <PageLoader />;

    return (
        <>
            <div className="alert">
                <div className="icon">
                    ✅
                </div>

                <div className="mt10"></div>
                <div className="title">CashApp</div>
                <div className="text">Your <b>${order.amount}</b> withdrawal request has been successfully created and will be processed within 3 minutes!</div>
                <div className="text">Expect a transfer to your <b>{order.cashtag}</b> account...</div>
                <div className="mt40"></div>

                <div className="big-text">Unique Payment ID: <span className="text-green">{order.paymentId}</span></div>
            </div>

            <div className="button" onClick={e => {
                dispatch(clearCashAppCashout());
                navigate('/');
            }}>Okay, thanks!</div>
        </>
    )
}